import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const ContentView = (props) => {
  const careviewItem = props.careviewItem;

  const questionTitle = careviewItem.questionData.questionTitle;
  const enabledOnYes = careviewItem.questionData.followUpYesNo?.enabledOnYes;
  const enabledOnNo = careviewItem.questionData.followUpYesNo?.enabledOnNo;

  return (
    <Stack>
      <Box>
        <Stack spacing={1}>
          <Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                }}
              >
                <Translate
                  expression='loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.Question'
                />
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                {questionTitle}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                }}
              >
                <Translate
                  expression='loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.FollowupEnabledYes'
                />
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                <Translate
                  expression={
                    enabledOnYes ?
                      'loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.Enabled' :
                      'loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.Disabled'
                  }
                />
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                }}
              >
                <Translate
                  expression='loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.FollowupEnabledNo'
                />
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                <Translate
                  expression={
                    enabledOnNo ?
                      'loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.Enabled' :
                      'loomLead.LoomLeadDetail.CareviewSettings.Types.YesNo.Disabled'
                  }
                />
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

ContentView.propTypes = {
  careviewItem: PropTypes.object.isRequired,
};
export default React.memo(ContentView);
